import React, { useEffect, useState } from 'react';
import { useNotionContext } from '../context';
import { cs } from '../utils';
import SvgTypeGitHub from '../icons/type-github';
export var ExternalComponentGithub = function (_a) {
    var original_url = _a.original_url, block = _a.block, className = _a.className;
    var components = useNotionContext().components;
    var url = new URL(original_url);
    var _b = useState(url.pathname.substring(1)), name = _b[0], setName = _b[1];
    var _c = useState(), githubRepo = _c[0], setGithubRepo = _c[1];
    useEffect(function () {
        // let's do a call to github api, by extracting repo from url
        fetch("https://api.github.com/repos/".concat(name))
            .then(function (response) {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        })
            .then(function (data) {
            setGithubRepo(data);
            setName(data.name);
        })["catch"](function (err) { return console.error(err); });
    }, [name]);
    return (React.createElement(components.link, { target: '_blank', rel: 'noopener noreferrer', href: original_url, className: cs('notion-external', block ? 'notion-external-block notion-row' : 'notion-external-mention', className) },
        React.createElement("div", { className: 'notion-external-image' },
            React.createElement(SvgTypeGitHub, null)),
        React.createElement("div", { className: 'notion-external-description' },
            React.createElement("div", { className: 'notion-external-title' }, name),
            githubRepo && (React.createElement("div", { className: 'notion-external-subtitle' }, "".concat(githubRepo.owner.login, " \u2022 Updated on ").concat(githubRepo.updated_at.substring(0, 10)))))));
};
//# sourceMappingURL=external-component-github.js.map